export function unit(unit) {
  return new Intl.NumberFormat('en', { style: 'unit', unit })
}

export function currency(currency) {
  return new Intl.NumberFormat('en', { style: 'currency', currency })
}
